<template>
    <div class="text-slider">
        <div class="text-flex">
            <div class="paragraph description-wrapper">
                <div class="name-position">
                    <h1 class="heading text-uppercase name">{{getCurrentSlide.name}}</h1>
                    <div class="gradient-line__vertical"></div>
                    <span class="position">{{getCurrentSlide.position}}</span>
                </div>
                <p class="description-text">
                    <img src="/static/img/landing_page/svg/quotes_blue.svg" class="blue-quotes"/>
                    {{getCurrentSlide.testimony}}
                </p>
                <div class="studio-flex">
                    <div class="studio-location">
                        <div class="gradient-line__horizontal"></div>
                        <span class="studio text-bold"> {{getCurrentSlide.studio}}</span>
                    </div>
                    <a v-if="getCurrentSlide.link" class="readMore" :href="getCurrentSlide.link.url" target="_blank">
                        <span class="readMore__text">{{getCurrentSlide.link.text}}</span>
                        <svg class="chevronRight" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" /></svg>
                    </a>
                    <div class="expat" v-if="getCurrentSlide.expat"> {{getCurrentSlide.expat}}</div>
                </div>
            </div>
        </div>
        <div ref="arrows" class="tns-carousel-arrows">
            <button class="button prev" @click="previousSlide"><i class="icons8-featured-left-arrow-01"
            ></i></button>
            <button class="button next" @click="nextSlide"><i class="icons8-featured-right-arrow-01"
            ></i></button>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'

    export default {
        name: "TestimonyTextSlider",
        props: {
            list: {
                type: Array,
                required: true
            },
            currentSlide: {}
        },

        methods: {
            ...mapActions('testimonies', {increment: 'increment', decrement: 'decrement'}),
            nextSlide() {
                this.increment()
                this.$emit('next')
            },
            previousSlide() {
                this.decrement()
                this.$emit('prev')
            }

        },
        computed: {
            ...mapGetters('testimonies', {sliderPositon: 'getSliderPosition'}),
            getSliderValue() {
                return this.sliderPositon
            },

            getCurrentSlide: function () {
                return this.list[this.currentSlide]
            }
        }
    }
</script>

<style scoped lang="scss" type="text/scss">
    @import "../../assets/scss/globals";

    .studio-location {
        display: inline-flex;
        align-items: center;
        padding: 0.5rem 0;
    }

    .chevronRight {
        height: 1.5rem;
        width: 1.5rem;
        color: black;
        margin-left: 0.25rem;
        transition: transform 200ms ease;
    }

    .readMore {
        display: inline-flex;
        align-items: center;
        color: black;
        padding: 0.5rem 1rem;

        &:hover .chevronRight{
            transform: translateX(5px);
        }

        @media(max-width: $compact--sm) {
            margin-top: 0.5rem;
            padding: 0.5rem 0;
        }
    }

    .readMore__text {
        text-decoration: underline;
        line-height: 1;
    }

    .description-wrapper {
        padding-left: 30px;
        @media (max-width: $compact) {
            padding-left: 10px;
        }
    }

    .description-text {
        position: relative;
        font-family: "Montserrat", sans-serif;
        font-weight: 300;
        font-size: 16px;
        line-height: 25px;
        letter-spacing: 0.14px;
        @media (min-width: $tablet) {
            min-height: 150px;
        }
        @media(max-width: $compact) {
            font-size: 13px;
            letter-spacing: 0.29px;
            line-height: 18px;
        }
    }

    .text-slider {
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.8);
        position: relative;
        padding: 30px;
        padding-left: 70px;
        padding-right: 70px;
        margin-top: -60px;
        min-height: auto !important;
        @media(max-width: $compact) {
            margin-top: 0;
            margin-bottom: 0;
            padding: 4em;
        }
        @media(max-width: 420px) {
            padding: 1em;
        }
        @media (max-width: 768px) {
            min-height: 460px;
        }
        @media(min-width: 768px) {
            min-height: 630px;
        }
        @media(min-width: 1200px) {
            min-height: 520px;
        }

    }

    .tns-carousel-arrows {

        @media(max-width: $tablet) {
            display: none;
        }
        .button {
            padding: 12px;
            background-color: black;
            color: white;
            position: absolute;
            font-size: 30px;
            top: 40%;
        }

        .next {
            right: -30px;
        }

        .prev {
            left: -30px;
        }
    }

    .studio {
        text-transform: uppercase;
        font-size: 14px;
        font-weight: 700;
        font-family: Montserrat, sans-serif;
    }

    .expat {
        width: 100%;
        text-transform: uppercase;
        font-size: 14px;
        font-weight: 400;
        font-family: Montserrat, sans-serif;
    }

    .text-flex {
        display: flex;
        @media (min-width: $tablet) {
            padding-left: 55px;
            margin-top: 2em;
        }
    }

    .blue-quotes {
        position: absolute;
        left: -50px;
        max-width: 57px;
        @media (max-width: $compact) {
            max-width: 35px;
        }
        @media (max-width: 420px) {
            max-width: 20px;
            left: -23px;
        }
        @media (min-width: $compact) {
            left: -65px;
        }
        @media (min-width: $tablet) {
            left: -80px;
        }
        top: 0;
    }

    .name-position {
        text-align: center;
        vertical-align: center;
        display: flex;
        flex-direction: row;

        @media(max-width: $tablet) {
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        .position {
            align-self: center;
            font-family: "Montserrat", sans-serif;
            font-size: 16px;
            letter-spacing: 1.42px;
            line-height: 36px;
            font-weight: 300;
            text-transform: uppercase;
            padding-left: 15px;
            @media(max-width: $compact) {
                font-size: 12px;
                letter-spacing: 1.07px;
                line-height: 36px;
            }
        }

        .name {
            font-size: 35px;
            line-height: 1.9;
            letter-spacing: 0.76px;
            @media(max-width: $compact) {
                font-size: 20px;
                letter-spacing: 0.4px;
            }
        }

    }

    .studio-flex {
        display: flex;
        justify-content: space-between;
        text-align: left;
        margin-top: 15px;
        margin-bottom: 20px;

        @media(max-width: $compact--sm) {
            flex-direction: column;
            align-items: left;
        }
    }

    .gradient-line__vertical {
        display: inline-block;
        width: 3px;
        height: 50px;
        margin-left: 15px;
        margin-right: 8px;
        background-image: -webkit-gradient(linear, right top, left top, from(rgba(110, 58, 203, 0.9)), to(rgba(0, 181, 242, 0.9)));
        background-image: linear-gradient(0deg, rgba(110, 58, 203, 0.9) 0%, rgba(0, 181, 242, 0.9) 100%);
        background-repeat: no-repeat;
        background-size: 100%;
        align-self: center;

        @media(max-width: $tablet) {
            display: none;
        }
    }

    .gradient-line__horizontal {
        display: inline-block;
        width: 30px;
        height: 2px;
        margin-bottom: 4px;
        margin-right: 10px;
        background-image: -webkit-gradient(linear, right top, left top, from(rgba(110, 58, 203, 0.9)), to(rgba(0, 181, 242, 0.9)));
        background-image: linear-gradient(270deg, rgba(110, 58, 203, 0.9) 0%, rgba(0, 181, 242, 0.9) 100%);
        background-repeat: no-repeat;
        background-size: 100% 15px;
    }

</style>



// WEBPACK FOOTER //
// src/components/sliders/TestimonyTextSlider.vue